<template>
  <div>
    <figure
      class="video-thumbnail"
      tabindex="0"
      role="button"
      @keydown.enter="showModal()"
      @keydown.space="showModal()"
      @click="showModal()"
    >
      <div class="image-container">
        <img
          class="thumbnail"
          :src="`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`"
          :alt="thumbnailAltText"
        />
        <div class="play-icon-container">
          <inline-svg
            class="play-icon"
            :src="require('./assets/play-icon.svg')"
          />
        </div>
      </div>
      <figcaption v-if="thumbnailCaption" class="title">
        {{ thumbnailCaption }}
      </figcaption>
    </figure>

    <client-only>
      <Portal v-if="displayModal" to="modal-container">
        <div role="dialog" aria-modal="true" :aria-labelledBy="modalCaption">
          <Modal :title="modalCaption" @close="closeModal()">
            <div class="yt-iframe-container">
              <youtube
                ref="yt"
                class="yt-iframe"
                :fit-parent="true"
                :resize="true"
                :video-id="videoId"
              />
            </div>
          </Modal>
        </div>
      </Portal>
    </client-only>
  </div>
</template>

<script>
import Vue from 'vue'
import Modal from '@sephora-asia/core-modal/Modal.vue'
import ClientOnly from 'vue-client-only'
import InlineSvg from 'vue-inline-svg'
import { Youtube } from 'vue-youtube'
import PortalVue from 'portal-vue'

Vue.use(PortalVue)

export default {
  name: 'VideoThumbnail',
  components: {
    ClientOnly,
    InlineSvg,
    Modal,
    Youtube
  },
  props: {
    /**
     * Caption for modal title
     */
    modalCaption: {
      type: String,
      default: ''
    },
    /**
     * Caption for modal title
     */
    thumbnailCaption: {
      type: String,
      default: ''
    },
    /**
     * Alt text for thumbnail image
     */
    thumbnailAltText: {
      type: String,
      required: true
    },
    /**
     * The url to the video to display in the modal
     */
    videoId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      displayModal: false,
      videoTime: 0
    }
  },
  methods: {
    showModal() {
      this.displayModal = true
      this.playVideo()
    },
    closeModal() {
      this.displayModal = false
      this.pauseVideo()
    },
    playVideo() {
      this.$emit('play-video')
      this.$nextTick(() => {
        this.$refs.yt.player.loadVideoById({
          videoId: this.videoId,
          startSeconds: this.videoTime
        })
      })
    },
    async pauseVideo() {
      this.videoTime = await this.$refs.yt.player.getCurrentTime()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .modal {
  .modal-content .modal-header .modal-title {
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    width: 100%;
  }

  .modal-body .yt-iframe-container {
    width: 100%;

    .yt-iframe {
      width: 100%;
    }
  }
}

.video-thumbnail {
  cursor: pointer;
  width: 300px;

  &:hover {
    color: $red;
  }

  .image-container {
    position: relative;
    width: 100%;

    .thumbnail {
      width: 100%;
    }

    .play-icon-container {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      top: 0;
      display: flex;
      background-color: rgba(0, 0, 0, 0.25);

      .play-icon {
        height: 35px;
        width: 35px;
        fill: $white;
        margin: auto;
      }
    }
  }

  .title {
    font-size: 14px;
    line-height: 1.2;
    padding-top: 9px;
    text-align: center;
    text-transform: capitalize;
  }
}
</style>
